module.exports = __webpack_public_path__ + "img/druid.5d32c543.svg";